import { Suspense, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import './scss/style.scss';
import './App.css'
import AuthRouter from './navigation/AuthRouter';
import { useColorModes } from '@coreui/react';
import { QueryClientProvider } from 'react-query';
import { queryClient } from './utils/ReactQueryConfig';
import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import useAuthValue from 'src/modules/authModule/Hooks/useAuthValue';

const App = () => {
  const { setColorMode } = useColorModes('coreui-free-react-admin-template-theme')
  const authState = useAuthValue();

  useEffect(() => {
    setColorMode('light')
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const user = authState?.user;
    if (user) {
      if (user.title) document.title = user.title;

      if (user.favicon) {
        let faviconLink = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
        if (!faviconLink) {
          faviconLink = document.createElement('link');
          faviconLink.rel = 'icon';
          document.head.appendChild(faviconLink);
        }
        faviconLink.href = user.favicon;
      }

      // Update manifest if available (you can adjust the property name as needed)
      const manifestUrl = (user as any).manifest_url;
      if (manifestUrl) {
        let manifestLink = document.querySelector("link[rel='manifest']") as HTMLLinkElement;
        if (!manifestLink) {
          manifestLink = document.createElement('link');
          manifestLink.rel = 'manifest';
          document.head.appendChild(manifestLink);
        }
        manifestLink.href = manifestUrl;
      }
    }
  }, [authState?.user]);
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Suspense
        // fallback={
        //   <div className="pt-3 text-center">
        //     <CSpinner color="primary" variant="grow" />
        //   </div>
        // }
        >
          <AuthRouter />
        </Suspense>
      </BrowserRouter>
      <ToastContainer />
    </QueryClientProvider>
  );
}

export default App;
